export interface ArticleItem {
  id: string;
  title: string;
  summary: string;
  content: string;
  coverImage: string;
  category: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  videoUrl: string;
}

export const articles: ArticleItem[] = [
  {
    id: 'a1',
    title: '新手必看：蘑菇种植入门指南',
    summary: '从零开始学习蘑菇种植，了解菌种选择、培养基配制、环境控制等基础知识，帮你迈出蘑菇种植第一步。',
    content: `<h2>蘑菇种植的乐趣与价值</h2><p>蘑菇种植是一项既有趣又有实际收益的爱好。无论你是想在阳台种几盆自己吃的食用菌，还是计划开展规模化商业种植，掌握基础知识都是成功的第一步。</p><h2>选择适合初学者的品种</h2><p>对于新手来说，平菇是最推荐的入门品种。它生长速度快、抗逆性强、对培养料要求不高，即使在简易环境下也能获得不错的产量。其次是香菇和杏鲍菇，稍有一定经验后可以尝试。</p><h2>培养基的配制</h2><p>培养基是蘑菇生长的"土壤"。常见配方包括木屑、棉籽壳、玉米芯等主料，配以麸皮、玉米粉等辅料。不同菇类对碳氮比有不同要求，需根据品种调整配方比例。</p><h2>环境控制三要素</h2><p>温度、湿度、通风是蘑菇生长的三大关键因素。大多数食用菌适宜生长温度在20-28°C之间，空气相对湿度需保持在85%-95%，同时需要适当通风以提供氧气并排出二氧化碳。</p><h2>常见问题与解决</h2><p>新手常遇到的问题包括杂菌污染、出菇不齐、菇体畸形等。这些问题大多与消毒不彻底或环境控制不当有关。建议从小的规模开始，逐步积累经验再扩大生产。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20various%20edible%20mushrooms%20growing%20in%20a%20home%20garden%20setting%20with%20a%20person%20hands%20gently%20touching%20fresh%20mushrooms%2C%20warm%20sunlight%2C%20green%20leaves%20background%2C%20peaceful%20organic%20gardening%2C%20shallow%20depth%20of%20field%2C%20lifestyle%20photography&width=1200&height=600&seq=article-a1&orientation=landscape',
    category: 'planting',
    author: '蘑菇种植达人',
    date: '2026-08-01',
    views: 52800,
    tags: ['新手入门', '蘑菇种植教程', '食用菌基础'],
    videoUrl: '',
  },
  {
    id: 'a2',
    title: '夏季高温期蘑菇管理要点',
    summary: '夏季高温对蘑菇生长影响巨大，本文详细讲解如何在炎热季节科学管理菇房，确保产量稳定。',
    content: `<h2>夏季高温对蘑菇的影响</h2><p>当气温超过30°C时，多数食用菌品种的生长会受到明显抑制。高温会导致菌丝生长缓慢、出菇减少、菇体品质下降，严重时甚至导致菌棒报废。</p><h2>降温措施一：物理降温</h2><p>在菇房顶部铺设遮阳网，减少太阳直射。使用水帘或喷雾系统进行蒸发降温，可有效降低菇房温度3-5°C。有条件的可安装空调或冷风机，精确控制菇房温度。</p><h2>降温措施二：管理调整</h2><p>高温期适当减少菌棒堆放密度，增加通风频率。浇水时间调整为早晚低温时段，避免中午浇水导致温差过大。对于某些品种，可适当减少覆土厚度以利散热。</p><h2>品种选择策略</h2><p>夏季可选择耐高温品种，如高温平菇、草菇等。草菇最适生长温度为30-35°C，是夏季种植的理想品种。合理安排品种轮作，让菇房全年都有产出。</p><h2>病虫害防治</h2><p>高温高湿环境容易引发病虫害。需加强菇房卫生管理，定期消毒。发现病菇及时摘除并深埋，防止病害扩散。可适当使用生物农药进行预防。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Mushroom%20grow%20room%20with%20cooling%20mist%20system%20active%2C%20fine%20water%20droplets%20in%20air%2C%20green%20shade%20netting%20visible%20through%20windows%2C%20healthy%20mushrooms%20growing%20on%20shelves%2C%20professional%20indoor%20farm%2C%20fresh%20cool%20atmosphere&width=1200&height=600&seq=article-a2&orientation=landscape',
    category: 'planting',
    author: '专业菇农老李',
    date: '2026-07-28',
    views: 36100,
    tags: ['夏季管理', '温度控制', '蘑菇种植技巧'],
    videoUrl: '',
  },
  {
    id: 'a3',
    title: '蘑菇成品分级标准详解',
    summary: '了解市场上蘑菇成品的分级标准，从大小、色泽、完整度等多维度评估，助你卖出好价钱。',
    content: `<h2>为什么要做成品分级</h2><p>蘑菇成品分级是提升产品附加值和市场竞争力的重要手段。统一的分级标准便于定价、包装和销售，让优质产品获得应有的价格回报，同时也方便消费者按需选择。</p><h2>通用分级指标</h2><p>蘑菇分级主要依据以下几个指标：菇盖大小与形状、色泽均匀度、菇体完整度、新鲜程度、有无病虫害痕迹等。不同品种的蘑菇在具体标准上有所差异。</p><h2>香菇分级标准</h2><p>一级香菇要求菇盖直径4-6cm，盖面呈茶褐色，菇形圆整、肉厚、卷边、无开伞；二级香菇菇盖直径3-7cm，允许轻微开伞；三级则对大小和形状要求较宽松。花菇因菌盖有自然裂纹，价值更高。</p><h2>包装与运输注意事项</h2><p>分级后的蘑菇应及时进行预冷处理，采用透气性好的包装材料。运输过程中避免挤压和剧烈震动，保持低温环境。精品菇建议使用定型托盘包装，提升产品档次感。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Graded%20fresh%20mushrooms%20sorted%20by%20size%20on%20a%20clean%20sorting%20table%2C%20three%20quality%20grades%20clearly%20separated%2C%20professional%20food%20processing%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20farm%20to%20market%20concept&width=1200&height=600&seq=article-a3&orientation=landscape',
    category: 'display',
    author: '农产品品控师',
    date: '2026-07-22',
    views: 24300,
    tags: ['成品分级', '品质标准', '蘑菇销售'],
    videoUrl: '',
  },
  {
    id: 'a4',
    title: '智能化菇房建设方案',
    summary: '利用物联网技术打造智能化菇房，实现温湿度自动调控、远程监控和数据化管理，大幅提升种植效率。',
    content: `<h2>智能菇房的时代到来</h2><p>随着物联网技术的发展，蘑菇种植正在从传统经验型向数据驱动型转变。智能菇房通过传感器实时采集环境数据，自动调控温湿度和通风，让蘑菇在最适宜的环境中生长。</p><h2>核心硬件配置</h2><p>智能菇房需要配备温湿度传感器、CO2浓度检测仪、光照传感器等数据采集设备，以及加湿器、加热器、通风扇、补光灯等执行设备。所有设备通过中央控制器联网管理。</p><h2>软件系统功能</h2><p>智能管理系统支持手机APP远程查看菇房实时数据，接收异常报警通知。系统可预设不同菇种、不同生长阶段的环境参数曲线，自动执行调控策略。历史数据分析功能帮助持续优化种植方案。</p><h2>投资与回报分析</h2><p>一套基础智能菇房系统的硬件投入约在5000-20000元之间，根据菇房面积和自动化程度而定。智能化管理可提升产量15%-30%，降低人工成本40%以上，通常1-2年即可收回投资。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20smart%20greenhouse%20interior%20with%20digital%20sensors%20and%20LED%20displays%20monitoring%20mushroom%20growth%2C%20automated%20irrigation%20system%2C%20clean%20high%20tech%20agriculture%2C%20rows%20of%20healthy%20mushrooms%2C%20futuristic%20farming%2C%20bright%20even%20lighting&width=1200&height=600&seq=article-a4&orientation=landscape',
    category: 'cultivation',
    author: '农业科技观察',
    date: '2026-07-18',
    views: 19200,
    tags: ['智能种植', '物联网', '菇房建设'],
    videoUrl: '',
  },
  {
    id: 'a5',
    title: '蘑菇采收时机判断技巧',
    summary: '掌握不同菇类的最佳采收时机，是保证蘑菇品质和产量的关键。本文分享实用的采收判断方法。',
    content: `<h2>为什么采收时机如此重要</h2><p>蘑菇的采收时机直接影响其商品价值和口感。采收过早，产量低；采收过晚，品质下降，菇盖开伞后商品性大打折扣。掌握最佳采收窗口，是每个菇农的必修课。</p><h2>平菇采收标准</h2><p>平菇在菌盖展开但尚未完全平展、边缘仍略内卷时为最佳采收期。此时菇体饱满、口感鲜嫩。从现蕾到采收通常需要3-5天，具体视温度而定。</p><h2>香菇采收标准</h2><p>香菇应在菌盖展开至七八分、菌膜刚破裂时采收。此时菇肉厚实、香味浓郁。花菇因菌盖有裂纹，需格外小心采收以避免损伤菇体。</p><h2>采收操作规范</h2><p>采收时应一手按住培养料，一手轻轻旋扭菇柄基部取下蘑菇，避免带起培养料。采后立即进行预冷处理，去除菇体田间热。分级包装应在低温环境中快速完成。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20person%20carefully%20harvesting%20mature%20mushrooms%20by%20hand%20in%20a%20sunlit%20greenhouse%2C%20basket%20half%20filled%20with%20fresh%20mushrooms%2C%20gentle%20morning%20light%2C%20peaceful%20farm%20scene%2C%20hands%20in%20soil%2C%20organic%20sustainable%20farming&width=1200&height=600&seq=article-a5&orientation=landscape',
    category: 'harvest',
    author: '资深菇农',
    date: '2026-07-14',
    views: 28700,
    tags: ['采收技巧', '时机判断', '品质管理'],
    videoUrl: '',
  },
  {
    id: 'a6',
    title: '蘑菇深加工产品开发指南',
    summary: '从初级农产品到高附加值深加工产品，探索蘑菇产业的更多可能性，打造自己的蘑菇品牌。',
    content: `<h2>为什么要做深加工</h2><p>初级蘑菇产品价格波动大、利润空间有限。通过深加工，可以将蘑菇转化为蘑菇酱、蘑菇干、蘑菇粉、蘑菇脆片等高附加值产品，利润可提升3-10倍。</p><h2>热门深加工方向</h2><p>目前市场热门的蘑菇深加工产品包括：即食蘑菇零食、蘑菇调味料、蘑菇保健品（如灵芝孢子粉）、蘑菇速食汤料等。选择方向时需考虑自身资源、技术能力和目标市场。</p><h2>加工技术要点</h2><p>不同产品对应不同加工工艺。冻干技术能最大程度保留蘑菇的营养和风味，但设备投入较大；热风干燥成本低，适合小规模起步；罐头加工需要专业杀菌设备，保质期长。</p><h2>品牌建设与营销</h2><p>好的产品需要好的包装和品牌故事。挖掘蘑菇的健康价值和文化内涵，通过短视频、直播等方式展示产品制作过程，建立消费者信任。线上线下结合拓展销售渠道。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Various%20mushroom%20processed%20products%20beautifully%20arranged%20on%20a%20display%20table%2C%20dried%20mushrooms%20in%20glass%20jars%2C%20mushroom%20powder%2C%20mushroom%20snacks%2C%20clean%20modern%20product%20photography%2C%20warm%20natural%20lighting%2C%20artisanal%20packaging%2C%20gourmet%20food&width=1200&height=600&seq=article-a6&orientation=landscape',
    category: 'making',
    author: '食品研发工程师',
    date: '2026-07-10',
    views: 16500,
    tags: ['深加工', '产品开发', '蘑菇品牌'],
    videoUrl: '',
  },
  {
    id: 'a7',
    title: '有机蘑菇认证流程全解析',
    summary: '想做有机蘑菇？本文详细解读有机认证的申请条件、审核流程和注意事项，助你顺利获得有机证书。',
    content: `<h2>有机认证的价值</h2><p>获得有机认证的蘑菇产品在市场上可获得30%-100%的溢价。消费者越来越关注食品安全和品质，有机认证是进入高端市场的通行证，也是品牌差异化的重要策略。</p><h2>认证前置条件</h2><p>申请有机蘑菇认证需要满足以下基本条件：使用有机认证的菌种和培养料、种植环境符合有机生产标准、不使用化学农药和化肥、建立完整的生产追溯体系。转换期通常需要1-3年。</p><h2>申请流程步骤</h2><p>第一步：选择有资质的认证机构；第二步：提交申请材料和生产计划；第三步：现场检查与抽样检测；第四步：认证审核与发证。整个流程通常需要3-6个月。</p><h2>持续合规管理</h2><p>获得认证后并非一劳永逸，认证机构每年都会进行监督检查。生产者需持续做好生产记录、投入品管理台账，确保持续符合有机标准要求。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Organic%20certified%20mushroom%20farm%20with%20certification%20badge%20on%20wooden%20wall%2C%20clean%20natural%20growing%20environment%2C%20healthy%20mushrooms%20in%20organic%20substrate%2C%20wooden%20shelves%2C%20sunlight%20streaming%20through%20windows%2C%20sustainable%20eco%20friendly%20agriculture&width=1200&height=600&seq=article-a7&orientation=landscape',
    category: 'cultivation',
    author: '有机认证顾问',
    date: '2026-07-06',
    views: 12100,
    tags: ['有机认证', '标准流程', '品质升级'],
    videoUrl: '',
  },
  {
    id: 'a8',
    title: '蘑菇常见病害识别与防治',
    summary: '图文并茂讲解蘑菇种植中常见的细菌性、真菌性病害及虫害的识别特征与科学防治方法。',
    content: `<h2>病害防治的重要性</h2><p>蘑菇病害是制约产量和品质的主要因素之一。及时发现并正确防治病害，可以避免大面积减产和经济损失。预防为主、综合防治是病害管理的核心理念。</p><h2>细菌性病害</h2><p>细菌性褐斑病是最常见的细菌病害，表现为菇盖上出现黄褐色水渍状斑点，严重时菇体腐烂发臭。防治要点是保持菇房卫生、控制湿度、避免菇面积水。</p><h2>真菌性病害</h2><p>木霉（绿霉）是蘑菇种植的头号大敌，在培养料上形成绿色霉层，与蘑菇菌丝竞争营养。预防关键是严格灭菌消毒、使用健康菌种、保持培养料适宜的pH值。</p><h2>虫害防治</h2><p>菇蚊、菇蝇幼虫会蛀食菇体，造成虫洞降低商品价值。可在菇房设置黄色粘虫板诱杀成虫，严重时可使用低毒生物杀虫剂进行防治。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Close%20up%20comparison%20of%20healthy%20mushrooms%20versus%20diseased%20mushrooms%20on%20a%20clean%20white%20background%2C%20scientific%20plant%20pathology%20style%2C%20clear%20visual%20differences%2C%20educational%20content%2C%20bright%20even%20lighting%2C%20detailed%20texture&width=1200&height=600&seq=article-a8&orientation=landscape',
    category: 'planting',
    author: '植物保护专家',
    date: '2026-07-02',
    views: 20300,
    tags: ['病害防治', '病虫害', '种植管理'],
    videoUrl: '',
  },
];

export const getArticleById = (id: string): ArticleItem | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (categorySlug: string): ArticleItem[] => {
  if (categorySlug === 'all') return articles;
  return articles.filter((a) => a.category === categorySlug);
};

export const getLatestArticles = (limit: number = 4): ArticleItem[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
};

export const getRelatedArticles = (currentId: string, category: string, limit: number = 3): ArticleItem[] => {
  return articles.filter((a) => a.id !== currentId && a.category === category).slice(0, limit);
};